import { defineMessages } from 'react-intl';

const messages = defineMessages({
    gridView: {
        id: 'be.itemGrid.gridView',
        description: 'Label for the list of files and folders displayed in a grid view',
        defaultMessage: 'Grid view',
    },
});

export default messages;
